import styled from 'styled-components'

export const NotesRowStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
